import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { TranslationService } from "@core-services/translation.service";
import { config, externalPaths } from "@config";

@Component({
	selector: "tax-possible-taxable-info-legacy-ui",
	templateUrl: "./tax-possible-taxable-info-legacy.component.html",
	styleUrls: ["./tax-possible-taxable-info-legacy.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class TaxPossibleTaxableInfoLegacyUIComponent implements OnInit {
	@Input() showLink = true;

	link = "";

	ngOnInit(): void {
		const language: string = TranslationService.getLanguageIsoCode() === "de" ? "de" : "en-us";
		this.link = `${config.helpcenterUrl}hc/${language}/articles/${externalPaths.taxes.hdLink}`;
	}
}
